/* global FirebaseWorker, katapultAuth */

import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/paper-dialog-scrollable/paper-dialog-scrollable.js';
import '@polymer/paper-progress/paper-progress.js';
import '../progress-bar/progress-bar.js';
import '../style-modules/paper-tooltip-style.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/paper-menu-button-style.js';
import '../../js/open-source/zipjs/zip.js';
import '../katapult-elements/katapult-button.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { Round } from '../../modules/Round.js';
import { HowLong } from '../../modules/Date.js';
import { Download } from '../../modules/Download.js';
import { isJobLocked } from '../katapult-maps-desktop/locked-job-dialog.js';

class OfflineManager extends PolymerElement {
  static get template() {
    return html`
      <style include="paper-tooltip-style paper-dialog-style paper-menu-button-style">
        paper-dialog-scrollable {
          --paper-dialog-scrollable: {
            padding: 0;
          };
        }
        .jobRow {
          display: flex;
          align-items: center;
          background-color: var(--paper-grey-200);
          color: var(--paper-grey-800);
          border-radius: 48px;
          padding: 4px;
          margin: 8px;
        }
        .jobRow > div {
          flex-grow: 1;
        }
        .jobRow > katapult-button {
          padding: 0;
          height: 24px;
          width: 24px;
          --katapult-button-paper-spinner-color: var(--primary-text-color-faded);
        }
        katapult-button {
          --katapult-button-paper-spinner: {
            padding: 2px;
            width: 24px;
            height: 24px;
            margin: 0;
          };
          --katapult-button-paper-spinner-color: white;
          --katapult-button-label: {
            max-width: 24px;
            top: 12px;
          };
        }
        progress-bar {
          background-color: var(--paper-grey-200);
          box-shadow: none;
          height: 24px;
          --progress-background-color: var(--paper-red-500);
          --progress-color: white;
          --color: var(--primary-text-color-faded);
          margin-bottom: 12px;
        }
        paper-menu-button {
          padding: 0;
          margin-left: 8px;
        }
        paper-menu-button > div {
          padding: 0;
        }
        paper-menu-button > div > div > iron-icon {
          margin-right: 8px;
        }
        paper-menu-button > div > div {
          padding: 0 8px;
          display: flex;
          flex-direction: row;
          align-items: center;
          color: var(--primary-text-color-faded);
          font-size: 11pt;
          outline: 0;
          white-space: nowrap;
          min-height: 48px;
          box-sizing: border-box;
        }
      </style>
      <paper-dialog id="offlineDialog" opened="{{opened}}">
        <!-- <iron-icon icon="cloud"></iron-icon> -->
        <div title="" secondary-color="">
          <katapult-button
            iconOnly
            noBorder
            color="var(--secondary-color)"
            icon="[[syncIcon]]"
            on-click="manuallyStoreAllData"
            label="Last Fetched Job Data: [[howLong(lastSynced)]]"
            loading="[[syncing]]"
          ></katapult-button>
          <span style="text-align: center;">manage offline jobs</span>
          <paper-menu-button id="menu" horizontal-align="right" no-overlap="">
            <katapult-button iconOnly noBorder icon="more_vert" color="var(--secondary-color)" slot="dropdown-trigger"></katapult-button>
            <div slot="dropdown-content">
              <!--<div>Sync Interval<paper-input style="width: 96px; margin-left: 8px;" min="1" type="number" no-label-float><span slot="suffix">min</span></paper-input></div>-->
              <!--<div style="min-height: 36px; font-style: italic; font-size: 10pt; color: var(--paper-grey-400)">Check Buttons Re-Sync Data</div>-->
              <template is="dom-if" if="[[allowSyncing(offline, syncing)]]">
                <div on-click="manuallyStoreAllData">
                  <iron-icon slot="item-icon" icon="notification:sync"></iron-icon>Sync All Jobs With Cloud
                </div>
              </template>
              <div on-click="openClearCachedJobsConfirmDialog">
                <iron-icon slot="item-icon" icon="delete"></iron-icon>Clear All Cached Jobs
              </div>
              <div on-click="showOfflineHelp"><iron-icon slot="item-icon" icon="help"></iron-icon>Need Help?</div>
            </div>
          </paper-menu-button>
        </div>
        <div content="">
          <template is="dom-if" if="[[storageLabel]]">
            <progress-bar max="[[quota]]" value="[[usage]]" label="[[storageLabel]]"></progress-bar>
          </template>
          <job-chooser
            id="jobChooser"
            selected="{{OMjobChooserJobId}}"
            user-group="[[userGroup]]"
            on-jobs-loaded="jobsLoaded"
            default-text="Select Job to Use Offline"
            offline="[[offline]]"
            no-create-new-job=""
          ></job-chooser>
          <!--<span style="font-size: 11pt; text-transform: uppercase; color: var(--primary-text-color-faded)">Offline Jobs:</span>-->
          <paper-dialog-scrollable dialog-element="[[$.offlineDialog]]">
            <template is="dom-repeat" items="[[cachedJobs]]" as="job">
              <div class="jobRow">
                <katapult-button
                  iconOnly
                  noBorder
                  icon$="[[jobIcon(job.jobId, jobFailFlags.*)]]"
                  loading="[[jobSyncing(job.jobId, jobSyncFlags.*)]]"
                  disabled="[[offline]]"
                  on-click="syncJobClick"
                ></katapult-button>
                <div on-click="openJob">[[job.name]]</div>
                <katapult-button
                  iconOnly
                  noBorder
                  noBackground
                  on-click="removeJobClicked"
                  icon="clear"
                  disabled="[[!canRemoveJob(job.jobId, jobSyncFlags.*, offline, jobId)]]"
                ></katapult-button>
              </div>
            </template>
          </paper-dialog-scrollable>
        </div>
        <div buttons="">
          <katapult-button dialog-dismiss color="var(--paper-grey-500)">Done</katapult-button>
        </div>
      </paper-dialog>

      <!-- Clear All Cached Job Data confirmation prompt -->
      <katapult-dialog id="clearCachedJobsConfirmDialog" title="Clear All Cached Jobs">
        <div>Are you sure you want to clear all cached job data from this device?</div>
        <div slot="buttons">
          <katapult-button on-tap="clearAllCachedJobs" color="var(--paper-red-500)">Clear</katapult-button>
          <katapult-button dialog-dismiss>Cancel</katapult-button>
        </div>
      </katapult-dialog>

      <!-- Backup Offline Data Step 1 -->
      <paper-dialog id="offlineHelpDialog" no-cancel-on-outside-click="">
        <div title="" secondary-color="">Backup Offline Data</div>
        <div content>
          <!--Backup Step-->
          <template is="dom-if" if="[[equal(offlineBackupDataStep, 'backup')]]">
            <p>Having trouble syncing data?</p>
            <p>Tap "Send Offline Data" to send Katapult your offline data. Katapult will then sync the data with this job.</p>
            <p>Once the data is successfully sent to Katapult, the app will clear your offline data and refresh so you can keep working.</p>
            <template is="dom-if" if="[[showFallbackOption]]">
              <p style="font-style: italic;">Sorry, this is taking longer than expected. Would you like to back up data manually?</p>
              <katapult-button on-click="tappedTryManualBackup" color="var(--secondary-color)">Try Manual Backup</katapult-button>
            </template>
            <template is="dom-if" if="[[backingUpData]]">
              <p>[[backupStatus]]</p>
              <paper-progress style="width: 100%;" value="{{backupPercentage}}" max="100"></paper-progress>
            </template>
          </template>
          <!--Success Step-->
          <template is="dom-if" if="[[equal(offlineBackupDataStep, 'success')]]">
            <p>Your offline data has been sent to Katapult successfully. The app will clear your offline data and refresh in:</p>
            <p>{{refreshTimeRemaining}}...</p>
          </template>
          <!--Fallback Step-->
          <template is="dom-if" if="[[equal(offlineBackupDataStep, 'fallback')]]">
            <p style="color:red">Error sending data.</p>
            <p>
              The app was not able to automatically send your offline data. Please tap "Download Data" to download your offline data to this
              device. Then, please email the backup file to:
            </p>
            <a style="font-weight:bold" href="mailto:katapultpro-mobilebackups@katapultengineering.com"
              >katapultpro-mobilebackups@katapultengineering.com</a
            >
          </template>
        </div>
        <div buttons>
          <!--Success Step-->
          <template is="dom-if" if="[[equal(offlineBackupDataStep, 'success')]]">
            <katapult-button dialog-dismiss color="var(--secondary-color)" on-click="clearSyncDataAndReload">Reload Now</katapult-button>
          </template>
          <!--Backup Step-->
          <template is="dom-if" if="[[equal(offlineBackupDataStep, 'backup')]]">
            <katapult-button on-click="tappedBackupData" loading="[[backingUpData]]" color="var(--secondary-color)"
              >Send Offline Data</katapult-button
            >
          </template>
          <!--Email Fallback Step-->
          <template is="dom-if" if="[[equal(offlineBackupDataStep, 'fallback')]]">
            <katapult-button on-click="tappedDownloadBackupData" color="var(--secondary-color)">Download Data</katapult-button>
          </template>
          <div style="display: flex; flex-grow: 1;"></div>
          <katapult-button on-click="closeOfflineHelpDialog" color="var(--paper-grey-500)">Cancel</katapult-button>
        </div>
      </paper-dialog>
      <!-- Clear Offline Data Fallback Step -->
      <paper-dialog id="clearSyncDataDialog" no-cancel-on-outside-click="">
        <div title="" red="">warning</div>
        <div content="">
          <p>Are you really sure you want to clear your offline data?</p>
          <p>
            Only do so if you have backed up your offline data and understand that your offline data can only be recovered by sending the
            data to Katapult.
          </p>
        </div>
        <div buttons="">
          <katapult-button on-click="tappedClearSyncData" loading="[[clearingSyncData]]" color="var(--paper-red-500)"
            >Yes, Clear Offline Data</katapult-button
          >
          <div style="display: flex; flex-grow: 1;"></div>
          <katapult-button on-click="closeClearSyncDataDialog" dialog-dismiss color="var(--paper-grey-500)">Cancel</katapult-button>
        </div>
      </paper-dialog>
      <!-- Backup Offline Data Email Fallback Step -->
      <paper-dialog id="syncDataClearedComfirmDialog" no-cancel-on-outside-click="">
        <div title="" secondary-color="">Offline Data Cleared</div>
        <div content="">
          <p>Your offline data has been cleared, please reload the page</p>
        </div>
        <div buttons="">
          <katapult-button dialog-dismiss color="var(--secondary-color)" on-click="reloadAfterClearSyncData">Reload</katapult-button>
        </div>
      </paper-dialog>
    `;
  }

  static get is() {
    return 'offline-manager';
  }
  static get properties() {
    return {
      cachedJobs: {
        type: Object,
        notify: true
      },
      jobId: {
        type: String,
        notify: true
      },
      jobChooserJobId: {
        type: String
      },
      jobKeys: {
        type: Array
      },
      jobSyncFlags: {
        type: Object,
        value: {}
      },
      jobFailFlags: {
        type: Object,
        value: {}
      },
      offline: {
        type: Boolean,
        value: false
      },
      OMjobChooserJobId: {
        type: String,
        observer: 'OMjobChooserJobIdChanged'
      },
      syncing: {
        type: Boolean,
        value: false,
        notify: true
      },
      syncIcon: {
        type: String,
        value: 'error'
      },
      userGroup: {
        type: String
      }
    };
  }
  static get observers() {
    return [
      'setLocalStorage(cachedJobs.*)',
      'jobSyncFlagsChanged(jobSyncFlags.*)',
      'jobFailFlagsChanged(jobFailFlags.*)',
      'updateSyncIcon(offline, syncFailed)',
      'cacheActiveJob(jobId, offline, cachedJobs.*)',
      'maybeSetupOfflineJob(jobChooserJobId, userGroup, offline)'
    ];
  }
  connectedCallback() {
    super.connectedCallback();

    this.storageHandler = async (e) => {
      if (e.key == 'cachedJobs') {
        this.cachedJobs = JSON.parse(e.newValue) || [];
      }
    };

    // Set up a listener to local storage to see if the user caches or removes offline jobs from another tab
    window.addEventListener('storage', this.storageHandler);
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    clearInterval(this.lastSyncedIntervalId);

    // Set up a listener to local storage to see if the user caches or removes offline jobs from another tab
    window.removeEventListener('storage', this.storageHandler);
  }
  ready() {
    super.ready();

    this._log = true;

    this.cachedJobs = JSON.parse(localStorage.getItem('cachedJobs') || '[]');

    this.offlineBackupDataStep = localStorage.getItem('offlineBackupDataStep');

    zip.workerScriptsPath = '../_resources/js/open-source/zipjs/';

    this.syncDataComplete = parseInt(localStorage.getItem('syncDataComplete'));
    this.lastSyncedIntervalId = setInterval(() => (this.lastSynced = Date.now() - this.syncDataComplete), 1000);
    this.refreshStorageUsage();

    FirebaseWorker.onChange('syncProgress', (syncProgress) => {
      this.log('Sync Progress Changed', syncProgress);
    });
  }
  async maybeSetupOfflineJob() {
    const jobId = this.jobChooserJobId;
    const jobIsLocked = false; //await isJobLocked(jobId);
    // Make sure we have the current jobId and the current userGroup
    if (jobId && this.userGroup && !jobIsLocked) {
      // TODO: make sure this gets called appropriately if we have already setup a job
      // TODO: possibly enhance this loading notification for the user
      this.set(`jobSyncFlags.${jobId}`, true);
      await FirebaseWorker.setCurrentJobId(jobId, this.userGroup)
        .then((res) => {
          // check if we should remove a job from the cachedJobs local storage
          if (res.clearedJob) this.removeJob(res.clearedJob);
          this.set('jobId', jobId);
          this.set(`jobSyncFlags.${jobId}`, false);
        })
        .catch((e) => {
          console.log('error setting up offline job', e);
        });
    } else {
      // if we did not have the data necessary to setup the job offline then set the jobId to ''
      this.set('jobId', '');
    }
  }
  open() {
    this.opened = true;
  }
  async cacheJob(jobId, activeJob = false) {
    if (!jobId) return;

    // Do nothing if the job is locked
    if (await isJobLocked(jobId)) return;

    let job = this.getCachedJob(jobId);
    if (!job) this.push('cachedJobs', { jobId });

    // if this is the active job then update the job name
    if (activeJob) await this.updateCachedJobName(job || this.getCachedJob(jobId));
    // Only store the job data if it's NOT the active job
    else this.storeJobData({ jobId });
  }
  async updateCachedJobName(job) {
    // this updates the specified job in the cachedJobs array with the latest name of the job
    if (this.userGroup) {
      let name =
        (this.$.jobChooser.items.find((x) => x.$key === job.jobId) || {}).name ||
        (await FirebaseWorker.ref(`photoheight/job_permissions/${this.userGroup}/jobs/${job.jobId}/name`)
          .once('value')
          .then((s) => s.val()));
      if (name) this.set(`cachedJobs.${this.cachedJobs.indexOf(job)}.name`, name);
    } else {
      this.log('Failed to update cached job name. userGroup is missing.');
    }
  }
  async cacheActiveJob() {
    if (!this.offline && this.jobId && this.jobId != 'undefined' && !this.getCachedJob(this.jobId)) {
      // Cache Job Temporarily.
      await this.cacheJob(this.jobId, true);
    }
  }
  canRemoveJob(jobId) {
    return !this.jobSyncing(jobId) && !this.offline && this.jobId != jobId;
  }
  close() {
    this.$.menu.close();
    this.opened = false;
  }
  equal(a, b) {
    return a == b;
  }
  getCachedJob(jobId) {
    return this.cachedJobs.find((x) => x.jobId === jobId);
  }
  howLong(x) {
    if (x && isNaN(x) == false) {
      return HowLong(x)[0] + ' Ago';
    }
    return 'Never';
  }
  jobsLoaded() {
    this.jobsChanged = !this.jobsChanged;
  }
  jobSyncFlagsChanged() {
    this.syncing = Object.values(this.jobSyncFlags).some((x) => x);
  }
  jobFailFlagsChanged() {
    this.syncFailed = Object.values(this.jobFailFlags).some((x) => x);
  }
  jobSyncing(jobId) {
    return this.get(`jobSyncFlags.${jobId}`);
  }
  jobIcon(jobId) {
    return this.get(`jobFailFlags.${jobId}`) ? 'error' : 'check_circle';
  }
  openJob(e) {
    this.dispatchEvent(new CustomEvent('open-job', { detail: { jobId: e.model.job.jobId } }));
  }
  async removeJob(jobId, deleteOfflineData) {
    let job = this.getCachedJob(jobId);
    if (job) {
      this.log(`Removing data for job ${job.jobId}...`);

      if (deleteOfflineData) {
        await FirebaseWorker.clearOfflineJob(job.jobId)
          .then(() => {
            this.log(`Removed data for job ${job.jobId}`);
          })
          .catch((err) => {
            this.log(`Failed to remove data for job ${job.jobId}`);
            throw err;
          });
      }

      this.splice('cachedJobs', this.cachedJobs.indexOf(job), 1);
    }
  }
  async refreshStorageUsage() {
    // Update memory used bar.
    if (navigator?.storage?.estimate) {
      let storage = await navigator.storage.estimate();
      this.usage = storage.usage;
      this.quota = storage.quota;

      let usageLabel = this.getStorageLabel(storage.usage);
      let quotaLabel = this.getStorageLabel(storage.quota);

      this.storageLabel = `${usageLabel.amount} ${usageLabel.unit} of ${quotaLabel.amount} ${quotaLabel.unit}`;
    } else {
      let usage = await this.getCrudeStorageEstimate();
      let usageLabel = this.getStorageLabel(usage);
      this.storageLabel = `~${usageLabel.amount} ${usageLabel.unit} of storage used`;
    }
  }
  async getCrudeStorageEstimate() {
    return new Promise((mainResolve) => {
      if (window.indexedDB) {
        let request = window.indexedDB.open('katapult-default');
        let storageUsed = 0;
        request.onsuccess = async () => {
          let db = request.result;
          let objectStores = db.objectStoreNames || [];
          for (let i = 0; i < objectStores.length; i++) {
            let objectStoreName = objectStores[i];
            storageUsed += objectStoreName.length;
            let transaction = db.transaction(objectStoreName, 'readwrite');
            let objectStore = transaction.objectStore(objectStoreName);

            let objectStoreData = await new Promise((resolve) => {
              objectStore.getAll().onsuccess = (event) => {
                resolve(event.target.result);
              };
            });

            storageUsed += JSON.stringify(objectStoreData).length;
          }
          mainResolve((storageUsed *= 2));
        };
      }
    });
  }
  getStorageLabel(amount) {
    let units = ['KB', 'MB', 'GB'];
    let unit = 'B';
    let compare = 1000;
    let newAmount = amount;
    while (amount >= compare && units.length) {
      newAmount /= 1000;
      unit = units.shift();
      compare *= 1000;
    }
    return { unit, amount: Round(newAmount, 1) };
  }
  log() {
    let console = window.console;
    if (console.getOriginalConsole) console = console.getOriginalConsole();
    this._log && console.debug(`%cOfflineManager:`, 'color: #9C27B0', ...arguments);
  }
  removeJobClicked(e) {
    this.removeJob(e.model.job.jobId, true);
  }
  OMjobChooserJobIdChanged() {
    if (this.OMjobChooserJobId != this.jobId) {
      this.cacheJob(this.OMjobChooserJobId);
    } else this.dispatchEvent(new CustomEvent('toast', { detail: { message: 'The current job is already setup for offline use.' } }));
    this.OMjobChooserJobId = '';
  }
  setLocalStorage() {
    this._setLocalStorageDebounce = Debouncer.debounce(this._setLocalStorageDebounce, timeOut.after(100), () => {
      localStorage.setItem('cachedJobs', JSON.stringify(this.cachedJobs));
    });
  }
  allowSyncing(offline, syncing) {
    return !offline && !syncing;
  }
  async manuallyStoreAllData() {
    // Make sure menu is closed.
    this.$.menu.close();
    // Forcefully store all data.
    this.storeAllData({ force: true });
  }
  async storeAllData(options) {
    options = options || {};
    if (!this.syncing || options.ignoreSyncing) {
      this.log(`Storing all data...`);
      await this.storeJobData({ force: options.force, ignoreSyncing: true }).then((res) => {
        let failed = res.find((x) => x.status == 'rejected');
        if (failed != null) {
          this.log(`Failed to store all data`, failed.reason);
        } else {
          this.syncDataComplete = Date.now();
          localStorage.setItem('syncDataComplete', this.syncDataComplete);
          this.log(`Successfully stored all data`);
        }
      });
    }
  }
  async storeJobData(options) {
    options = options || {};
    options.force = options.force || false;

    if (!this.offline && (!this.syncing || options.ignoreSyncing)) {
      if (this.userGroup != null) {
        let jobsToStore = [];
        // if a jobId is specified then only store that job
        if (options.jobId != null) {
          let job = this.getCachedJob(options.jobId);
          if (job) jobsToStore = [job];
          else this.log(`Failed to store jobId ${options.jobId}. Did not exist in list of cached jobs.`);
        } else if (Array.isArray(this.cachedJobs)) {
          // if no jobId is specified, store all jobs that are not the active job
          jobsToStore = this.cachedJobs.filter((job) => job.jobId != this.jobId);
        }

        let storePromises = jobsToStore.map(async (job) => {
          this.log(`Storing data for job ${job.jobId}...`);

          this.set(`jobSyncFlags.${job.jobId}`, true);

          // Update name on job.
          this.updateCachedJobName(job);

          // store all the necessary job data in FirebaseIDB
          return FirebaseWorker.setupOfflineJob(job.jobId, options.force);
        });

        return Promise.allSettled(storePromises).then((res) => {
          let failed = res.find((x) => x.status == 'rejected' || x.value?.err);
          if (failed != null) {
            this.set(`jobFailFlags.${failed.value?.jobId}`, true);
            let reason = failed.reason || failed.value?.err;
            this.log(`Failed to store data for job ${failed.value?.jobId}`, reason);
            throw reason;
          } else {
            // loop through each successfull job
            res.forEach((result) => {
              this.set(`jobSyncFlags.${result.value.jobId}`, false);
              this.set(`jobFailFlags.${result.value.jobId}`, false);
              this.log(`Successfully stored data for job ${result.value.jobId}`);
            });
          }
          return res;
        });
      } else {
        this.log('Failed to store data. UserGroup is missing.');
      }
    }
  }
  syncJobClick(e) {
    // No need to store job data if the selected job is the current one
    if (e.model.job.jobId != this.jobId) this.storeJobData({ jobId: e.model.job.jobId, force: true });
  }
  updateSyncIcon() {
    if (this.offline) this.syncIcon = 'cloud_off';
    else if (this.syncFailed) this.syncIcon = 'error';
    else this.syncIcon = 'cloud_done';
  }

  ///////////////////////////////////////////////////////////
  //// Functions for downloading and clearing offline data
  ///////////////////////////////////////////////////////////
  showOfflineHelp() {
    this.close();
    // If the step is not already clear, then reset it
    if (this.offlineBackupDataStep != 'clear') {
      this.resetBackupStep();
    }
    this.$.offlineHelpDialog.open();
  }
  async tappedBackupData() {
    this.backingUpData = true;
    this.backupPercentage = 0;
    this.backupDataBlob = null;

    // Create zip writer.
    this.backupStatus = 'Starting backup';
    this.backupPercentage = 5;
    let writer = await new Promise((res) => zip.createWriter(new zip.BlobWriter(), res));

    // Download update data.
    this.backupStatus = 'Gathering offline data';
    for (let path of ['$swapCollections', '$update_1', '$update_2', '$syncError', '$log', '$version']) {
      let json = await FirebaseWorker.ref(path)
        .getCachedData()
        .then((s) => s.val());
      let blob = new Blob([JSON.stringify(json, null, 4)], { type: 'application/json' });
      await new Promise((res) => writer.add(`update_data/${path}.json`, new zip.BlobReader(blob), res));
      this.backupPercentage += 5;
    }

    // Download all job data.
    let incrementAmount = 15 / Object.keys(this.cachedJobs || {}).length;
    this.backupStatus = 'Gathering job data';
    for (let job of this.cachedJobs) {
      let json = {};
      json.nodes = await FirebaseWorker.ref(`photoheight/jobs/${job.jobId}/nodes`)
        .once('value')
        .then((s) => s.val());
      json.connections = await FirebaseWorker.ref(`photoheight/jobs/${job.jobId}/connections`)
        .once('value')
        .then((s) => s.val());
      json.geohash = await FirebaseWorker.ref(`photoheight/jobs/${job.jobId}/geohash`)
        .once('value')
        .then((s) => s.val());
      json.gps_log = await FirebaseWorker.ref(`photoheight/jobs/${job.jobId}/gps_log`)
        .once('value')
        .then((s) => s.val());
      let blob = new Blob([JSON.stringify(json, null, 4)], { type: 'application/json' });
      await new Promise((res) => writer.add(`job_data/${job.jobId}.json`, new zip.BlobReader(blob), res));
      this.backupPercentage += incrementAmount;
    }

    this.backupDataBlob = await new Promise((res) => writer.close(res));

    try {
      // After 10 seconds, so the manual option if we didn't already succeed
      setTimeout(() => {
        if (this.backingUpData == true && this.offlineBackupDataStep != 'fallback' && this.offlineBackupDataStep != 'success') {
          this.showFallbackOption = true;
          setTimeout(() => {
            this.$.offlineHelpDialog.refit();
          }, 1);
        }
      }, 1000 * 10);
      // Upload the blob file for the user
      let uid = 'no_uid';
      if (katapultAuth && katapultAuth.user && katapultAuth.user.uid) {
        uid = katapultAuth.user.uid;
      }
      this.backupStatus = 'Uploading data';
      let storagePath = `mobile_offline_backup/${this.userGroup || 'no_user_group'}/${uid}/${new Date().toString()}`;
      let storageRef = firebase.storage().ref(storagePath);
      let uploadTask = storageRef.put(this.backupDataBlob);
      // Monitor the upload progress
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          // Progress
          this.backupPercentage = 50 + (snapshot.bytesTransferred / snapshot.totalBytes) * 25;
        },
        (e) => {
          // Error
          this.errorUploadingBackupData(e);
        },
        () => {
          this.backupStatus = 'Notifying Katapult';
          // Success
          firebase
            .functions()
            .httpsCallable('email')({ template: 'mobileOfflineDataBackup', userGroup: this.userGroup || 'no_user_group', storagePath })
            .then(async (result) => {
              if (this.offlineBackupDataStep != 'fallback') {
                this.showFallbackOption = false;
                this.backupStatus = 'Done';
                this.backupPercentage = 100;
                this.backingUpData = false;
                let secondsLeft = 10;
                this.refreshTimeRemaining = `${secondsLeft} seconds`;
                this.updateBackupStep('success');
                let countdownInterval = setInterval(async () => {
                  if (secondsLeft <= 0) {
                    clearInterval(countdownInterval);
                    await this.clearSyncDataAndReload();
                  } else {
                    secondsLeft -= 1;
                    this.refreshTimeRemaining = `${secondsLeft} second${secondsLeft == 1 ? '' : 's'}`;
                  }
                }, 1000);
              }
            })
            .catch((e) => {
              this.errorUploadingBackupData(e);
            });
        }
      );
    } catch (e) {
      this.errorUploadingBackupData(e);
    }
  }
  errorUploadingBackupData(e) {
    console.log('Error uploading backup data', e);
    this.updateBackupStep('fallback');
  }
  tappedTryManualBackup() {
    this.updateBackupStep('fallback');
  }
  tappedDownloadBackupData() {
    if (this.backupDataBlob) {
      Download(this.backupDataBlob, `${config.firebaseData.name} Offline Data Backup (${new Date().toLocaleString()}).zip`);
      this.promptClearSyncData();
    }
  }
  promptClearSyncData() {
    this.updateBackupStep('clear');
    this.$.offlineHelpDialog.close();
    this.$.clearSyncDataDialog.open();
  }
  async clearSyncData() {
    this.clearingSyncData = true;
    await FirebaseWorker.ref('$update_1').setCachedData(null);
    await FirebaseWorker.ref('$update_2').setCachedData(null);
    await FirebaseWorker.ref('$sentSyncErrorNotificationEmail').setCachedData(null);
    this.clearingSyncData = false;
  }
  async tappedClearSyncData() {
    await this.clearSyncData();
    this.$.clearSyncDataDialog.close();
    this.$.syncDataClearedComfirmDialog.open();
    this.resetBackupStep();
  }
  async clearSyncDataAndReload() {
    await this.clearSyncData();
    this.closeOfflineHelpDialog();
    this.reloadAfterClearSyncData();
  }
  reloadAfterClearSyncData() {
    this.resetBackupStep();
    window.location.reload();
  }
  closeOfflineHelpDialog() {
    this.$.offlineHelpDialog.close();
    this.resetBackupStep();
  }
  closeClearSyncDataDialog() {
    this.$.offlineHelpDialog.close();
    this.resetBackupStep();
  }
  resetBackupStep() {
    this.backingUpData = false;
    this.backupStatus = null;
    this.backupPercentage = 0;
    this.showFallbackOption = false;
    this.updateBackupStep('backup');
  }
  updateBackupStep(newStep) {
    this.offlineBackupDataStep = newStep;
    localStorage.setItem('offlineBackupDataStep', this.offlineBackupDataStep);
  }
  openClearCachedJobsConfirmDialog() {
    this.$.clearCachedJobsConfirmDialog.open();
  }
  clearAllCachedJobs() {
    this.cachedJobs.forEach((job) => {
      if (this.canRemoveJob(job.jobId)) this.removeJob(job.jobId, true);
    });
    this.$.clearCachedJobsConfirmDialog.close();
  }
  ////////////////////////////////////////////////////////////////
  //// End Functions for downloading and clearing offline data
  ////////////////////////////////////////////////////////////////
}
window.customElements.define(OfflineManager.is, OfflineManager);
